import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button } from '@ufc/uikit'
import { KioskInboundSection } from '@ufc/domains/incoming-materials'

export const Route = createFileRoute('/inbound')({
  component: InboundPage,
})

function InboundPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-4">
      <Button variant="ghost" onClick={() => navigate({ to: '/' })}>
        ←
      </Button>
      <KioskInboundSection />
    </div>
  )
}
